import { render, staticRenderFns } from "./BundleComponentProduct.vue?vue&type=template&id=1d54b395&"
import script from "./BundleComponentProduct.vue?vue&type=script&lang=js&"
export * from "./BundleComponentProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports